import { cn } from "@/lib/utils";

/** The five units the API accepts, labelled for a shopkeeper. */
export const MEASUREMENT_UNITS = [
  { value: "Kg", label: "Kg" },
  { value: "g", label: "g" },
  { value: "L", label: "L" },
  { value: "mL", label: "mL" },
  { value: "u", label: "unité" },
] as const;

export function UnitPicker({ value, onChange }: { value: string; onChange: (unit: string) => void }) {
  return (
    <div className="flex flex-wrap gap-2">
      {MEASUREMENT_UNITS.map((unit) => {
        const selected = unit.value === value;
        return (
          <button
            key={unit.value}
            type="button"
            onClick={() => onChange(unit.value)}
            aria-pressed={selected}
            className={cn(
              "h-11 rounded-full border px-4 text-[15px] transition",
              selected
                ? "border-foreground bg-foreground font-semibold text-background"
                : "border-input bg-card hover:bg-muted",
            )}
          >
            {unit.label}
          </button>
        );
      })}
    </div>
  );
}

export function unitLabel(unit: string): string {
  return MEASUREMENT_UNITS.find((u) => u.value === unit)?.label ?? unit;
}

/** Only "unité" inflects; the symbols (Kg, L…) never take an s. */
export function unitLabelFor(unit: string, quantity: number): string {
  const label = unitLabel(unit);
  return label === "unité" && Math.abs(quantity) >= 2 ? "unités" : label;
}
